import { AudioPitchStretchBoxAdapter } from "./AudioPitchStretchBoxAdapter";
import { AudioTimeStretchBoxAdapter } from "./AudioTimeStretchBoxAdapter";
export var AudioPlayMode;
(function (AudioPlayMode) {
    AudioPlayMode.isAudioPlayMode = (mode) => mode instanceof AudioPitchStretchBoxAdapter || mode instanceof AudioTimeStretchBoxAdapter;
})(AudioPlayMode || (AudioPlayMode = {}));
